/* global GM_STATE */

export function isWishlistEnabled() {
  return GM_STATE?.integrations?.enableWishlist === true
}
